import type { NormalTokenSelectorProps } from '@ui/components/SwapDialog/NormalTokenSelector';
import { NormalTokenSelector } from '@ui/components/SwapDialog/NormalTokenSelector';
import { Token } from '@ui/config/token';
import { isTokenOnH2 } from '@ui/config/token/types';

import { useH2SwapForm } from './useH2SwapForm';

type H2NormalTokenSelectorProps = Partial<NormalTokenSelectorProps> & {
  isSelectable?: boolean;
};

export const H2NormalTokenSelector = ({
  isSelectable = true,
  ...props
}: H2NormalTokenSelectorProps) => {
  const fromToken = useH2SwapForm((s) => s.fromToken);
  const toToken = useH2SwapForm((s) => s.toToken);

  const onSelectToken = (newToken: Token) => {
    if (!isTokenOnH2(newToken)) return;
    if (fromToken !== Token.Agent) {
      useH2SwapForm.setState({ fromToken: newToken });
    } else {
      if (newToken === Token.zkCRO)
        throw new Error('zkCRO is not supported as target');
      useH2SwapForm.setState({ toToken: newToken });
    }
  };

  return (
    <NormalTokenSelector
      isSelectable={isSelectable}
      fromToken={fromToken}
      toToken={toToken}
      onSelectToken={onSelectToken}
      {...props}
    />
  );
};
